import QcSmartNotificationSettingPostInterface from "@app/Interface/QcSmartNotificationPostInterface";


export default class QcSmartNotificationSettingPostModel implements QcSmartNotificationSettingPostInterface {
    fpuId: number;
    enableQc: boolean;
    enableSmart: boolean;

    constructor () {
        this.fpuId = 0;
        this.enableQc = false;
        this.enableSmart = false;
    }

}